import { IEnvironment } from '../environments'
import { IUserCapabilities } from '../models/User'

export function getDefaultEnvironment(): IEnvironment {
  return {
    platform: 'web',
    os: 'browser',
    target: 'dev'
  }
}

export function getMockCapabilities(): IUserCapabilities {
  return {
    franchiseId: 1000,
    myFranchisees: true,
    superuser: true,
    updateTicketEmailField: true,
    retailOrganisation: false,
    usePhotoGallery: true,
    hazardMenu: true,
    accessHazard: true,
    useAutocomplete: false,
    useTicketType: true,
    username: 'Dennis Branding',
    timeZone: 'Pacific/Auckland',
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy hh:mm:ss a',
    allowSendIncidentEmail: true
  }
}

export function getMockCapabilitiesNoTicketType(): IUserCapabilities {
  return {
    franchiseId: 1000,
    myFranchisees: true,
    superuser: true,
    updateTicketEmailField: true,
    retailOrganisation: false,
    usePhotoGallery: true,
    hazardMenu: true,
    accessHazard: true,
    useAutocomplete: false,
    useTicketType: false,
    username: 'Dennis Branding',
    timeZone: 'Pacific/Auckland',
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy hh:mm:ss a',
    allowSendIncidentEmail: true
  }
}
